// extracted by mini-css-extract-plugin
export default {"Sidemenu":"Sidemenu_Sidemenu__Ww2bz","Buttons":"Sidemenu_Buttons__WgC5A","Disabled":"Sidemenu_Disabled__HugrZ"};